/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Remove_Tool_Confirm_ButtonInputs */



/**
* | output |
* | --- |
* | "Remove tool" |
*
* @param {Rights_Tools_Remove_Tool_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_remove_tool_confirm_button = /** @type {((inputs?: Rights_Tools_Remove_Tool_Confirm_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Remove_Tool_Confirm_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tool entfernen")
	return /** @type {LocalizedString} */ ("Remove tool")
});